'use client';

import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';

import { ScrollTopButtonBase } from '@packages/modules/src/ScrollTopButton/ScrollTopButton';
import { useAbTesting } from '@packages/shared/src/abtesting/useAbTesting/useAbTesting';

import { filterSettingsFab } from '../../activeFeatureFlags';
import { getTestId } from '../../utils/featureFlags/getTestId';
/**
 * Scroll to top button for search pages (MBA, SERP and ZeroResultsPage)
 * Shows only when scrolling up after having scrolled down on the product list
 * */
export const SearchScrollTopAutoHideButton: FC = () => {
  const { setOutcome } = useAbTesting();

  const [showButton, setShowButton] = useState(false);

  const lastScrollY = useRef(0);
  const inactivityTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onAfterClick = () => {
    // remove if A/B test is finished
    setOutcome(getTestId(filterSettingsFab), {
      SCROLL: 1,
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const isScrollingUp = currentY < lastScrollY.current;
      const hasScrolledDown = currentY > window.innerHeight;

      // Clear existing timeout
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }

      // Show on scroll up, hide on scroll down
      if (isScrollingUp && hasScrolledDown) {
        setShowButton(true);
        // Auto-hide after 4s of inactivity
        inactivityTimeoutRef.current = setTimeout(() => setShowButton(false), 4000);
      } else {
        setShowButton(false);
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className={`z-app-bar fixed transition-opacity duration-500 ${showButton ? 'opacity-100' : 'pointer-events-none opacity-0'} top-2 right-0 left-0 flex items-center justify-center md:top-auto md:right-[2%] md:bottom-4 md:left-auto md:justify-start`}
    >
      <ScrollTopButtonBase onAfterClick={onAfterClick} />
    </div>
  );
};
